// Generated by tools/extract_smb2_stage_names.mjs
// Source: SMB2-NTSC-ROM/stgname/usa.str

export const SMB2_STAGE_NAMES: Readonly<Record<number, string>> = {
  1: "CONVEYERS",
  2: "FLOATERS",
  3: "SLOPES",
  4: "SLIDERS",
  5: "SPINNING TOP",
  6: "CURVE BRIDGE",
  7: "BANKS",
  8: "EATEN FLOOR",
  9: "HOPPERS",
  10: "COASTER",
  11: "BUMPY CHECK",
  12: "SWELL",
  13: "GRAVITY SLIDER",
  14: "INCHWORMS",
  15: "TOTALITARIANISM",
  16: "ALTERNATIVE",
  17: "JUNCTION",
  18: "PRO SKATERS",
  19: "GIANT COMB",
  20: "BEEHIVE",
  21: "DYNAMIC MAZE",
  22: "TRIANGLE HOLES",
  23: "LAUNCHERS",
  24: "RANDOMIZER",
  25: "COIN SLOTS",
  26: "SEESAW BRIDGES",
  27: "ARTHROPOD",
  28: "WORMHOLE",
  29: "FREE FALL",
  30: "MELTING POT",
  31: "MAD SHUFFLE",
  32: "BEAD SCREEN",
  33: "JUMP MACHINE",
  34: "ZIGZAG SLOPE",
  35: "TOWER",
  36: "TOGGLE",
  37: "FLUCTUATION",
  38: "COMBINATION",
  39: "PUNCHED SEESAWS",
  40: "OPERA",
  41: "BRANDISHED",
  42: "TIERS",
  43: "CLIFFS",
  44: "NARROW PEAKS",
  45: "DETOUR",
  46: "SWITCH INFERNO",
  47: "FOLDERS",
  48: "QUICK TURN",
  49: "PISTONS",
  50: "SOFT CREAM",
  51: "MOMENTUM",
  52: "ENTANGLED PATH",
  53: "TOTTERS",
  54: "VORTEX",
  55: "WARP",
  56: "TRAMPOLINES",
  57: "SWING SHAFT",
  58: "LINEAR SEESAWS",
  59: "SERIAL JUMP",
  60: "CROSS FLOORS",
  61: "SPINNING SAW",
  62: "CHIPPED PIPES",
  63: "FLAT MAZE",
  64: "GUILLOTINE",
  65: "CORK SCREW",
  66: "ORBITERS",
  67: "TWIN BASIN",
  68: "AIR HOCKEY",
  201: "SIMPLE",
  202: "HOLLOW",
  203: "BUMPY",
  204: "SWITCHES",
  205: "BOWL",
  206: "FLOATERS",
  207: "SLOPES",
  208: "SLIDERS",
  209: "SPINNING TOP",
  210: "CURVE BRIDGE",
  211: "CONVEYERS",
  212: "BUMPY CHECK",
  213: "ALTERNATIVE",
  214: "JUNCTION",
  215: "BEAD SCREEN",
  216: "FLUCTUATION",
  217: "FOLDERS",
  218: "QUICK TURN",
  219: "LINEAR SEESAWS",
  220: "BIRTH",
  221: "BANKS",
  222: "EATEN FLOOR",
  223: "HOPPERS",
  224: "COASTER",
  225: "BOARD PARK",
  226: "SWELL",
  227: "GRAVITY SLIDER",
  228: "INCHWORMS",
  229: "TOTALITARIANISM",
  230: "LEVELER",
  231: "ORGANIC FORM",
  232: "REVERSIBLE GEAR",
  233: "STEPPING STONES",
  234: "DRIBBLES",
  235: "U.R.L.",
  236: "MAD RINGS",
  237: "CURVY OPTIONS",
  238: "TWISTER",
  239: "DOWNHILL",
  240: "RAMPAGE",
  241: "PRO SKATERS",
  242: "GIANT COMB",
  243: "BEEHIVE",
  244: "DYNAMIC MAZE",
  245: "TRIANGLE HOLES",
  246: "LAUNCHERS",
  247: "RANDOMIZER",
  248: "COIN SLOTS",
  249: "SEESAW BRIDGES",
  250: "ARTHROPOD",
  251: "AUTO DOORS",
  252: "HEAVY SPHERE",
  253: "STAGGER",
  254: "U.F.O.",
  255: "RING BRIDGES",
  256: "DOMES",
  257: "AMIDA LOT",
  258: "LONG SLIDER",
  259: "GRID BRIDGE",
  260: "TEAPOT",
  261: "WORMHOLE",
  262: "FREE FALL",
  263: "MELTING POT",
  264: "MAD SHUFFLE",
  265: "PARTITION",
  266: "JUMP MACHINE",
  267: "ZIGZAG SLOPE",
  268: "TOWER",
  269: "TOGGLE",
  270: "PACHINKO",
  271: "COMBINATION",
  272: "PUNCHED SEESAWS",
  273: "OPERA",
  274: "BRANDISHED",
  275: "TIERS",
  276: "CLIFFS",
  277: "NARROW PEAKS",
  278: "DETOUR",
  279: "SWITCH INFERNO",
  280: "EARTHQUAKE",
  281: "SPIRAL BRIDGE",
  282: "WAVY OPTION",
  283: "OBSTACLE",
  284: "DOMINO",
  285: "SIEVE",
  286: "FLOCK",
  287: "DOUBLE SPIRAL",
  288: "HIERARCHY",
  289: "8 BRACELETS",
  290: "BANANA HUNTING",
  291: "PISTONS",
  292: "SOFT CREAM",
  293: "MOMENTUM",
  294: "ENTANGLED PATH",
  295: "TOTTERS",
  296: "VORTEX",
  297: "WARP",
  298: "TRAMPOLINES",
  299: "SWING SHAFT",
  300: "FIGHTERS",
  301: "SERIAL JUMP",
  302: "CROSS FLOORS",
  303: "SPINNING SAW",
  304: "CHIPPED PIPES",
  305: "FLAT MAZE",
  306: "GUILLOTINE",
  307: "CORK SCREW",
  308: "ORBITERS",
  309: "TWIN BASIN",
  310: "AIR HOCKEY",
  311: "CHARGE",
  312: "STRATA",
  313: "PUZZLE",
  314: "GIANT SWING",
  315: "5 DRUMS",
  316: "FREE THROW",
  317: "PENDULUMS",
  318: "CONICAL SLIDER",
  319: "CONSTRUCTION",
  320: "TRAIN WORM",
  321: "CENTRIFUGAL",
  322: "SWING BRIDGES",
  323: "CYLINDERS",
  324: "PASSAGE",
  325: "NOTCH",
  326: "INTERMITTENT",
  327: "LONG TORUS",
  328: "SPASMODIC",
  329: "DOUBLE TWIN",
  330: "CLOCK FACE",
  331: "VARIABLE WIDTH",
  332: "STRIKER",
  333: "OOPARTS",
  334: "PLANETS",
  335: "SLICED CHEESE",
  336: "8 SEESAWS",
  337: "SYNCHRONIZED",
  338: "HELIX",
  339: "DIZZY SYSTEM",
  340: "NINTENDO",
  341: "TRAINING",
  342: "GIMMICK",
  343: "MOUNTAIN",
  344: "DISORDER",
  345: "3D MAZE",
  346: "LABYRINTH",
  347: "POSTMODERN",
  348: "REVOLUTION",
  349: "INVISIBLE",
  350: "CREATED BY",
} as const;

export function getSmb2StageName(stageId: number): string | null {
  if (!Number.isFinite(stageId)) {
    return null;
  }
  const key = Math.trunc(stageId);
  const name = SMB2_STAGE_NAMES[key];
  return typeof name === 'string' ? name : null;
}
